export default __webpack_public_path__ + "static/media/green-house.b19119c2.jpg";